import styled from 'styled-components';
import { Container as RawContainer, media, spacing } from 'ui';
import { Sidebar, Wrapper as SecondWrapper } from 'ui/sidebar';
import logoEseis from 'images/eseis-colored.svg';
import logoSyndicOne from 'images/logo-syndic-one-colored.svg';
import logoViva from 'images/logo-viva-colored.svg';
import logoEcopro from 'images/logo-ecopro-colored.svg';
import logoNeuf from 'images/logo-neuf-colored.svg';
import logoTradition from 'images/logo-tradition.svg';
import { SERGIC_OFFER } from './constants';
import backgroundEseis from 'images/background-eseis.jpg';
import backgroundViva from 'images/background-viva.jpg';
import backgroundSyndicOne from 'images/background-syndic-one.jpg';
import backgroundEcopro from 'images/background-ecopro.jpg';
import { LanguageSelector } from 'components/LanguageSelector';
import { BoxDescription } from 'ui/auth';

export const Content = styled.div`
  flex: 1;
`;

export const Container = styled(RawContainer)`
  flex-direction: column;
  display: flex;
  padding: ${({ theme }) => theme.spacing(2)};

  ${media.tablet`
    padding: ${({ theme }) => theme.spacing(3)};
  `}
`;

export const Wrapper = styled.div`
  background-color: ${({ theme }) => theme.background};
  color: ${({ theme }) => theme.text};
  min-height: 100vh;
  position: relative;
  z-index: 1;
`;

export const Background = styled.div`
  background-image: url(${SERGIC_OFFER === 'VSY' || SERGIC_OFFER === 'VQC'
    ? backgroundViva
    : SERGIC_OFFER === 'DIR'
    ? backgroundSyndicOne
    : SERGIC_OFFER === 'ECO'
    ? backgroundEcopro
    : backgroundEseis});
  flex: 1;
  background-size: cover;
  background-position: center center;
`;

const LanguageContainer = styled.div`
  display: flex;
`;

export const getLogo = () => {
  switch (SERGIC_OFFER) {
    case 'ESE':
      return logoEseis;
    case 'VSY':
      return logoViva;
    case 'VQC':
      return logoTradition;
    case 'ECO':
      return logoEcopro;
    case 'DIR':
      return logoSyndicOne;
    default:
      return logoNeuf;
  }
};

const getLogoAlternativeText = () => {
  switch (SERGIC_OFFER) {
    case 'ESE':
      return 'eseis syndic';
    case 'VSY':
    case 'VQC':
      return 'Viva syndic';
    case 'ECO':
      return 'e-copro';
    case 'DIR':
    default:
      return 'Syndic One';
  }
};

export const Logo = () => (
  <img
    src={getLogo()}
    alt={getLogoAlternativeText()}
    style={{ marginBottom: spacing(2), width: 180 }}
  />
);

const App = () => {
  return (
    <Wrapper>
      <SecondWrapper style={{ minHeight: '100vh' }}>
        <Sidebar style={{ flex: '0 0 700px' }}>
          <Container hasVerticalPadding style={{ minHeight: '100vh' }}>
            <Logo />

            <Content>
              <BoxDescription>{'Chers clients,'}</BoxDescription>
              <BoxDescription>
                {
                  'Une opération de maintenance informatique est actuellement en cours.'
                }
              </BoxDescription>
              <BoxDescription>
                {
                  "Votre espace client sera indisponible du jeudi 15 mai 20H jusqu'au dimanche 18 mai."
                }
              </BoxDescription>
              <BoxDescription>{'Merci de votre compréhension.'}</BoxDescription>
              <BoxDescription>{'Votre service client'}</BoxDescription>
            </Content>

            <LanguageContainer>
              <LanguageSelector top />
            </LanguageContainer>
          </Container>
        </Sidebar>

        <Background />
      </SecondWrapper>
    </Wrapper>
  );
};

export default App;
